var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 19.5C19.5 17.0146 21.5146 15 24 15C26.4853 15 28.5 17.0146 28.5 19.5V21C28.5 23.4853 26.4853 25.5 24 25.5C21.5146 25.5 19.5 23.4853 19.5 21V19.5ZM18.8158 30.8158C19.3383 30.2935 20.0469 30 20.7856 30H27.2142C27.9531 30 28.6617 30.2935 29.184 30.8158C29.7064 31.3383 30 32.0469 30 32.7856C30 33.6141 30.6715 34.2856 31.5 34.2856C32.3284 34.2856 33 33.6141 33 32.7856C33 31.2513 32.3904 29.7796 31.3053 28.6945C30.2203 27.6096 28.7487 27 27.2142 27H20.7856C19.2513 27 17.7796 27.6096 16.6945 28.6945C15.6096 29.7796 15 31.2513 15 32.7856C15 33.6141 15.6716 34.2856 16.5 34.2856C17.3284 34.2856 18 33.6141 18 32.7856C18 32.0469 18.2935 31.3383 18.8158 30.8158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 24C3 12.402 12.402 3 24 3C35.598 3 45 12.402 45 24C45 35.598 35.598 45 24 45C12.402 45 3 35.598 3 24ZM22.5 6.0616V7.5C22.5 8.32842 23.1716 9 24 9C24.8284 9 25.5 8.32842 25.5 7.5V6.0616C34.2447 6.78303 41.217 13.7553 41.9384 22.5H40.5C39.6716 22.5 39 23.1716 39 24C39 24.8284 39.6716 25.5 40.5 25.5H41.9384C41.217 34.2447 34.2447 41.217 25.5 41.9384V40.5C25.5 39.6716 24.8284 39 24 39C23.1716 39 22.5 39.6716 22.5 40.5V41.9384C13.7553 41.217 6.78303 34.2447 6.0616 25.5H7.5C8.32842 25.5 9 24.8284 9 24C9 23.1716 8.32842 22.5 7.5 22.5H6.0616C6.78303 13.7553 13.7553 6.78303 22.5 6.0616Z",
    fill: "url(#paint0_linear_1_279)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_279",
    x1: 33.122,
    y1: 12.4655,
    x2: 13.4704,
    y2: 37.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#9DE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490049,
    stopColor: "#FA7C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8CED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.725d866fd28dbe3c7c65250cb4a5312c.svg";
export { ForwardRef as ReactComponent };